const OUTER_R = 60;
const DEFAULT_INNER_R = 35;
const POSITION_STATUS_INNER_R = 32;

const DonutChart = ({
  icon,
  data,
  title,
  totalValue,
  centerLabel,
  layout = "default",
}) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const innerR =
    layout === "position-status" ? POSITION_STATUS_INNER_R : DEFAULT_INNER_R;

  let cumulativePercentage = 0;
  const createPath = (percentage, cumPct, innerRadius) => {
    const startAngle = cumPct * 360;
    const endAngle = (cumPct + percentage) * 360;

    const startAngleRad = (startAngle - 90) * (Math.PI / 180);
    const endAngleRad = (endAngle - 90) * (Math.PI / 180);

    const largeArcFlag = percentage > 0.5 ? 1 : 0;

    const x1 = 75 + OUTER_R * Math.cos(startAngleRad);
    const y1 = 75 + OUTER_R * Math.sin(startAngleRad);
    const x2 = 75 + OUTER_R * Math.cos(endAngleRad);
    const y2 = 75 + OUTER_R * Math.sin(endAngleRad);

    const x3 = 75 + innerRadius * Math.cos(endAngleRad);
    const y3 = 75 + innerRadius * Math.sin(endAngleRad);
    const x4 = 75 + innerRadius * Math.cos(startAngleRad);
    const y4 = 75 + innerRadius * Math.sin(startAngleRad);

    return `M ${x1} ${y1} A ${OUTER_R} ${OUTER_R} 0 ${largeArcFlag} 1 ${x2} ${y2} L ${x3} ${y3} A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${x4} ${y4} Z`;
  };

  const renderFullDonut = (item, index, innerRadius) => {
    const outerR = OUTER_R;
    const cx = 75;
    const cy = 75;
    const startOuterX = cx;
    const startOuterY = cy - outerR;
    const midOuterX = cx;
    const midOuterY = cy + outerR;
    const startInnerX = cx;
    const startInnerY = cy - innerRadius;
    const midInnerX = cx;
    const midInnerY = cy + innerRadius;
    const fullPath = `
      M ${startOuterX} ${startOuterY}
      A ${outerR} ${outerR} 0 1 1 ${midOuterX} ${midOuterY}
      A ${outerR} ${outerR} 0 1 1 ${startOuterX} ${startOuterY}
      L ${startInnerX} ${startInnerY}
      A ${innerRadius} ${innerRadius} 0 1 0 ${midInnerX} ${midInnerY}
      A ${innerRadius} ${innerRadius} 0 1 0 ${startInnerX} ${startInnerY}
      Z
    `;
    return (
      <path
        key={index}
        d={fullPath}
        fill={item.color}
        stroke="#fff"
        strokeWidth="2"
      />
    );
  };

  const renderDonutSvg = () => (
    <svg width="150" height="150" viewBox="0 0 150 150">
      {data.map((item, index) => {
        const percentage = total > 0 ? item.value / total : 0;

        if (percentage === 1) {
          return renderFullDonut(item, index, innerR);
        }
        if (percentage === 0) {
          return null;
        }

        const path = createPath(percentage, cumulativePercentage, innerR);
        cumulativePercentage += percentage;

        return (
          <path
            key={index}
            d={path}
            fill={item.color}
            stroke="#fff"
            strokeWidth="2"
          />
        );
      })}
    </svg>
  );

  const legendItems = (
    <>
      {data.map((item, index) => (
        <div key={index} className="position-status-legend-item">
          <div
            className="position-status-legend-dot"
            style={{ backgroundColor: item.color }}
          />
          <span className="position-status-legend-label">{item.label}</span>
          <span className="position-status-legend-value">{item.value}</span>
        </div>
      ))}
    </>
  );

  if (layout === "position-status") {
    return (
      <div className="chart-container chart-container--position-status monthly-trends">
        <h3 className="chart-title">
          {icon}
          {title}
        </h3>
        <div className="position-status-body">
          <div className="position-status-left">
            <div className="position-status-total-container">
              <div className="position-status-total">{totalValue}</div>
              <div className="position-status-total-label">{centerLabel}</div>
            </div>
            <div className="position-status-legend">{legendItems}</div>
          </div>
          <div className="position-status-chart">
            <div className="donut-chart">{renderDonutSvg()}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="chart-container">
      <h3 className="chart-title">
        {icon}
        {title}
      </h3>
      <div className="text-center">
        <div className="stat-value">{totalValue}</div>
        <div className="stat-subtitle-2">{centerLabel}</div>
      </div>

      <div className="donut-chart mx-auto">{renderDonutSvg()}</div>

      <div className="mt-3">
        {data.map((item, index) => (
          <div
            key={index}
            className="d-flex justify-content-between align-items-center mb-2"
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded"
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: item.color,
                }}
              />
              <span className="small">{item.label}</span>
            </div>
            <span className="small fw-medium">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;
